module.exports = __webpack_public_path__ + "img/respecth-xml.475c966b.png";